package com.trevorwiebe.timesheet.core.domain.dto

import kotlinx.serialization.Serializable

@Serializable
data class RateDto(
    val id: String,
    val description: String,
    val userFacing: Boolean,
    val defaultRate: Boolean,
    val rateCode: String,
    // Default keeps deserialization working for rate documents written before this field existed.
    val overtimeRateCode: String = ""
)
